//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

import template from './streams-drawer-empty-state.html';
import './streams-drawer-empty-state.less';
import { CollectionStatusType } from '@apis/collections/CollectionStatusType';
import {
  StreamModalType,
  StreamsDrawerStreamType,
} from '@streams-drawer/streams-drawer-constants';

class StreamsDrawerEmptyState {
  public streamType: StreamsDrawerStreamType;
  public streamsDrawerStreamType = StreamsDrawerStreamType;
  public streamModalType = StreamModalType;

  public isRecommendationStream: boolean;
  public isAssetFeedsStream: boolean;
  public isGalleryUploadsStream: boolean;
  public isTaggedByCuralateStream: boolean;
  public isConnectStream: boolean;
  public moderationStatus: CollectionStatusType;

  public $onChanges() {
    this.setStreamType();
  }

  public $onInit() {
    this.setStreamType();
  }

  private setStreamType() {
    if (this.isGalleryUploadsStream) {
      this.streamType = StreamsDrawerStreamType.GALLERY_UPLOADS;
    } else if (this.isTaggedByCuralateStream) {
      this.streamType = StreamsDrawerStreamType.TAGGED_BY_CURALTE;
    } else if (this.isConnectStream) {
      this.streamType = StreamsDrawerStreamType.CONNECT;
    } else if (this.isRecommendationStream) {
      this.streamType = StreamsDrawerStreamType.RECOMMENDED;
    } else if (this.isAssetFeedsStream) {
      this.streamType = StreamsDrawerStreamType.ASSET_FEEDS;
    } else {
      this.streamType = StreamsDrawerStreamType.STANDARD;
    }
  }
}

angular.module('curalate').component('streamsDrawerEmptyState', {
  bindings: {
    filterCount: '<',
    isAssetFeedsStream: '<',
    isGalleryUploadsStream: '<',
    isRecommendationStream: '<',
    isTaggedByCuralateStream: '<',
    isConnectStream: '<',
    moderationStatus: '<',
    onOpenEditStreamModal: '&',
  },
  controller: StreamsDrawerEmptyState,
  template,
});
